import Vue from 'vue'
import App from './App.vue' 
import store from './store'
import router from './router'
import{ BootstrapVue, BootstrapVueIcons } from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
//import "./assets/estilo.css"
import Vuelidate from 'vuelidate'
import { BSpinner } from 'bootstrap-vue'

import './interceptor'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
// import Autocomplete from '@trevoreyre/autocomplete-vue'
// import '@trevoreyre/autocomplete-vue/dist/style.css'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use (BootstrapVueIcons)
Vue.component('b-spinner', BSpinner)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
// Vue.use(Autocomplete) 

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
